// export const base_url = "https://sheheryaralamkhan.com/projects/supergallery_dev/supergallery/module/";
// export const BASE_PATH = "/projects/supergallery_dev";
export const base_url = "https://www.supergallery.nl/supergallery/module/";
export const BASE_PATH = "";